<sdc-bo-dialog
  headerTitle="Create new Group Link"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'group-link-create-modal'">
  @if (currentStep === 1) {
    <p class="step-description">
      With group links, you can create a <b>dedicated mini-site</b> for a
      specific group. <br />
      You can configure it with <b>different variables</b> than those used for
      the public portal.
    </p>
  }
  @if (currentStep === 2) {
    <p class="step-description">
      Do you want the Group link to be Private? <br />
      Click on Enable and enter the <b>Patron IDs</b> that will be allowed to
      access the Group link.
    </p>
  }
  <div class="pt-4 content-wrapper">
    @if (currentStep === 1) {
      <div class="form-container">
        <div class="input-block">
          <span class="label-text"
            >Name <span class="mandatory-asterisk">*</span></span
          >
          <input
            [attr.data-cy]="'group-link-create-modal-name-input'"
            type="text"
            placeholder="Enter group link name"
            [(ngModel)]="item.name"
            [class.invalid-input]="hashValidator.name" />
          @if (hashValidator.name) {
            <span class="text-[80%] error-color"> The entry is mandatory </span>
          }
        </div>
        <div class="input-block">
          <span class="label-text">URL</span>
          <div class="input-with-icon">
            <input
              [attr.data-cy]="'group-link-create-modal-slug-input'"
              type="text"
              [(ngModel)]="slug"
              disabled
              class="disabled" />
            <ng-icon
              name="lucideLayers"
              class="copy-icon"
              size="1.1rem"
              (click)="copyToClipboard()"
              title="Copy to clipboard"></ng-icon>
          </div>
        </div>
        <div class="input-block">
          <span class="label-text">Description</span>
          <textarea
            [attr.data-cy]="'group-link-create-modal-description-input'"
            placeholder="Provide a brief description"
            [(ngModel)]="item.description"
            [class.invalid-input]="hashValidator.description"></textarea>
        </div>
        <div class="form-grid">
          <div class="input-block">
            <span class="label-text">Buyer Type Name</span>
            <input
              [attr.data-cy]="'group-link-create-modal-buyer-type-name-input'"
              type="text"
              [(ngModel)]="item.defaultBuyerTypeName" />
          </div>
          <div class="input-block">
            <span class="label-text"
              >Buyer Type ID <span class="mandatory-asterisk">*</span></span
            >
            <input
              [attr.data-cy]="'group-link-create-modal-buyer-type-id-input'"
              type="text"
              [(ngModel)]="item.defaultBuyerTypeId"
              [class.invalid-input]="hashValidator.defaultBuyerTypeId" />
            @if (hashValidator.defaultBuyerTypeId) {
              <span class="text-[80%] error-color">
                Must be a positive number
              </span>
            }
          </div>
          <div class="input-block">
            <span class="label-text"
              >Min Sale Tickets <span class="mandatory-asterisk">*</span></span
            >
            <input
              [attr.data-cy]="'group-link-create-modal-min-tickets-input'"
              type="number"
              [(ngModel)]="item.minTickets"
              [class.invalid-input]="hashValidator.minTickets" />
            @if (hashValidator.minTickets) {
              <span class="text-[80%] error-color">
                Must be a positive number
              </span>
            }
          </div>
          <div class="input-block">
            <span class="label-text"
              >Max Sale Tickets <span class="mandatory-asterisk">*</span></span
            >
            <input
              [attr.data-cy]="'group-link-create-modal-max-tickets-input'"
              type="number"
              [(ngModel)]="item.maxTickets"
              [class.invalid-input]="hashValidator.maxTickets" />
            @if (hashValidator.maxTickets) {
              <span class="text-[80%] error-color">
                Must be a number greather than min sale tickets
              </span>
            }
          </div>
          <div class="input-block">
            <span class="label-text">Sales Rep ID</span>
            <input
              [attr.data-cy]="'group-link-create-modal-sales-rep-id-input'"
              type="number"
              [(ngModel)]="item.salesRepId"
              placeholder="Sales Rep ID"
              [class.invalid-input]="hashValidator.salesRepId" />
            @if (hashValidator.salesRepId) {
              <span class="text-[80%] error-color">
                Must be a positive number when set
              </span>
            }
          </div>
        </div>
        <div class="form-grid">
          <div class="input-block">
            <span class="label-text"
              >ADA Hold Codes <span class="mandatory-asterisk">*</span></span
            >
            <tagify
              name="ada-hold-codes"
              class="tags-textarea"
              [formControl]="adaHoldCodesForm"
              inputClass="w-full flex justify-start items-start"
              [settings]="settings"
              [class.invalid-input]="hashValidator.adaHoldCodes"></tagify>
            @if (hashValidator.adaHoldCodes) {
              <span class="text-[80%] error-color">
                The entry is mandatory
              </span>
            }
          </div>
          <div class="input-block">
            <span class="label-text"
              >Regular Hold Codes
              <span class="mandatory-asterisk">*</span></span
            >
            <tagify
              name="regular-hold-codes"
              class="tags-textarea"
              [formControl]="regularHoldCodesForm"
              inputClass="w-full flex justify-start items-start"
              [settings]="settings"
              [class.invalid-input]="hashValidator.regularHoldCodes"></tagify>
            @if (hashValidator.regularHoldCodes) {
              <span class="text-[80%] error-color">
                The entry is mandatory
              </span>
            }
          </div>
        </div>
      </div>
      <div class="flex flex-col ms-6">
        <div class="toggle-group mt-0 mb-4 px-4 py-2">
          <div class="toggle-wrapper">
            <input
              id="status-toggle"
              type="checkbox"
              [(ngModel)]="item.isActive" />
            <label for="status-toggle">
              Group Link:
              <b class="text-[80%]">{{
                item.isActive ? 'Enabled' : 'Disabled'
              }}</b>
            </label>
          </div>
        </div>
        <div class="toggle-group mt-0 mb-4 px-4 py-2">
          <div class="toggle-wrapper">
            <input
              id="select-all-events-create"
              type="checkbox"
              [(ngModel)]="isAllEventsSelected"
              (change)="onSelectAllEventsChange($event)" />
            <label for="select-all-events-create"> Select all events </label>
          </div>
        </div>
        <gs-event-selector
          [class.invalid-input]="hashValidator.events"
          [ngModel]="selectedEventIds"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onEventSelectionChange($event)"
          (selectionMeta)="onEventSelectionMeta($event)"></gs-event-selector>
        @if (hashValidator.events) {
          <span class="text-[80%] error-color">
            At least one event must be selected
          </span>
        }
      </div>
    }

    @if (currentStep === 2) {
      <div class="w-full form-container">
        <div class="toggle-group mt-0">
          <div class="toggle-wrapper">
            <input
              id="private-selling-toggle"
              type="checkbox"
              [(ngModel)]="item.isPrivateSelling" />
            <label for="private-selling-toggle">
              <b class="text-[80%]">{{
                item.isPrivateSelling ? 'Enabled' : 'Disabled'
              }}</b>
            </label>
          </div>
        </div>
        @if (item.isPrivateSelling) {
          <div class="shadow-none mt-6 p-0 border-0 whitelist-container">
            <div class="whitelist-header">
              <ng-icon name="lucideLock" size="1em"></ng-icon>
              <span
                >Private Selling Whitelist
                <span class="mandatory-asterisk">*</span></span
              >
            </div>
            <tagify
              name="tagify-element"
              class="tags-textarea"
              [formControl]="form"
              inputClass="w-full flex justify-start items-start"
              [settings]="settings"
              [class.invalid-input]="
                hashValidator.privateSellingWhitelists
              "></tagify>
            @if (hashValidator.privateSellingWhitelists) {
              <span class="text-[80%] error-color">
                At least one item must be added to the whitelist
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      variant="secondary"
      [attr.data-cy]="'group-link-create-modal-cancel-button'"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      variant="primary"
      [attr.data-cy]="'group-link-create-modal-confirm-button'"
      (onClick)="onConfirm()">
      {{ currentStep === 1 ? 'Next' : 'Save' }}
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
